// Main SPA entry point
import './main-files/base'
import { App as CapacitorApp } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import initLiveUpdate from '@/plugins/liveUpdate'
import Vue from 'vue'
import VueRouter from 'vue-router'
import vuetify from '@/plugins/vuetify'
import store from '@/store'
import router from '@/router'
import moment from 'moment'
import App from '@/App.vue'
import vueVimeoPlayer from "vue-vimeo-player"
import '@/plugins/maps'
import VueConfetti from 'vue-confetti'
import VueTour from 'vue-tour'

require('vue-tour/dist/vue-tour.css')

// Detect mobile app early so axios interceptor and router guard can use it
window.IS_MOBILE_APP = Capacitor.isNativePlatform()

Vue.use(VueRouter)
Vue.use(vueVimeoPlayer)
Vue.use(VueConfetti)
Vue.use(VueTour)

Vue.prototype.$moment = moment

// Initialize current user if available
if (window.CURRENT_USER) {
    store.commit('current_user/setCurrentUser', window.CURRENT_USER)
}

// Initialize live updates for native apps
initLiveUpdate()

// Mount main SPA
const app = new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')

// Deep link event listener
router.onReady(() => {
  CapacitorApp.addListener('appUrlOpen', async function (event) {
    let slug = event.url.split(/\.(com|net|dev)/).pop();

    if (!slug) return;

    // Resolve short URLs via API since PHP redirects don't work in native deep link flow
    const shortUrlMatch = slug.match(/^\/l\/(.+)/);
    if (shortUrlMatch) {
      try {
        const { Api } = await import('@/plugins/axios');
        const response = await Api.get(`/l/${shortUrlMatch[1]}`);
        if (response.data.base_url) {
          slug = response.data.base_url;
        }
      } catch (e) {
        router.push({ name: 'dashboard' });
        return;
      }
    }

    app.$nextTick(() => {
      router.push({ path: slug });
    });
  });
});